import React from 'react';
import CheckboxFilter from "../CheckboxFilter.js";
import Cookies from "js-cookie";
import {useParams} from "react-router-dom";
import Api from "../../Api.js";

function TaskCheckBlock({form,setForm}) {
    const {id} = useParams();

    const profession = Cookies.get("profession") || localStorage.getItem("profession") || "manager"
    const checked = async (name,e) => {
       try {
           setForm((prev) => ({
               ...prev,
               [name]: e.target.checked,
           }));
           await Api.patchTask({[name]: e.target.checked,},id)
       }catch (e) {

       }
    }
    return (
        <>
            {profession === "manager" &&
            (form?.status === "process" || form?.status === "end") && (
                <CheckboxFilter
                    title="Ստուգված է"
                    my_task={form?.checked}
                    onChange={(ev) =>checked('checked',ev)}
                />
            )}

            <CheckboxFilter
                title="Տեսանելի է բոլորի համար"
                my_task={form?.visible_for_client}
                onChange={(ev) =>checked('visible_for_client',ev)}
            />
        </>
    );
}

export default TaskCheckBlock;